// extracted by mini-css-extract-plugin
export var btnBlock = "chance-module--btn-block--e32bd";
export var chance = "chance-module--chance--46019";
export var col = "chance-module--col--35264";
export var row = "chance-module--row--f5d86";